import { RedirectNoticeService } from '../../../services/redirect-notice.service';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

@Component({
  selector: 'redirect-notice',
  templateUrl: './redirect-notice.component.html',
  styleUrl: './redirect-notice.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RedirectNotice {
  protected redirectNotice = inject(RedirectNoticeService);
}
